import { render, staticRenderFns } from "./PanelTitleBar.vue?vue&type=template&id=38a2cecc&scoped=true&"
import script from "./PanelTitleBar.vue?vue&type=script&lang=js&"
export * from "./PanelTitleBar.vue?vue&type=script&lang=js&"
import style0 from "./PanelTitleBar.vue?vue&type=style&index=0&id=38a2cecc&scoped=true&lang=css&"
import style1 from "./PanelTitleBar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a2cecc",
  null
  
)

export default component.exports